module.exports = __webpack_public_path__ + "img/cj-lihui.a57c49a2.png";